<template>
    <span v-if="feedShareId">
        <b-button
            class="align-baseline"
            title="Create"
            variant="link"
            @click="handleCreateProperty"
            v-if="airbnbStatus.status === 'NOT_CREATED'"
        >
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Update"
            variant="link"
            v-b-modal="updateModalId"
            v-else
        >
            <font-awesome-icon :icon="['fas', 'arrows-rotate']"></font-awesome-icon>
        </b-button>
        <modal
            :id="updateModalId"
            title="Update Property"
            ok-title="Update"
            @shown="onModalShown"
            @ok="handleUpdateProperty"
            >Update Airbnb property?</modal
        >
    </span>
</template>

<script>
import Modal from '../../generic/modal/modal.vue';

export default {
    components: { Modal },
    data() {
        return { feedShareId: 0, airbnbStatus: null, updateModalId: '' };
    },
    created() {
        this.feedShareId = this.params.data && this.params.data.id;
        this.airbnbStatus = this.params.data && this.params.data.airbnb_status;
        this.updateModalId = `update-property-modal-${this.feedShareId}`;
    },
    methods: {
        onModalShown() {
            this.params.api.clearFocusedCell();
        },
        handleCreateProperty() {
            this.params.create && this.params.create(this.params.data);
        },
        handleUpdateProperty() {
            this.params.update && this.params.update(this.params.data);
        },
    },
};
</script>